export const drugTestingPages = {
  sv: {
    navLabel: "Drogtestning",
    privatePrefix: "Privat",
    hub: {
      label: "Drogtestning",
      title: "Drogtestning med salivtest eller urinprov",
      subtitle:
        "Boka privat salivtest eller urinprov för 1 500 kr per provpaket. Proverna analyseras i samarbete med Unilabs. Företag kontaktar oss för offert.",
      primaryCta: "Välj provpaket och boka",
      priceNote: "Privata provpaket · 1 500 kr",
      purposeTitle: "Vad ska drogtestet användas till?",
      companyTitle: "Drogtestning för företagshälsovård",
      companyText: "Förebyggande, vid nyanställning och vid misstanke. MRO-granskning av alla drogprover.",
      companyCta: "Till företagshälsovård",
      intygTitle: "Drogtestning för ett intyg",
      intygText: "När provtagningen ska ingå i ett läkarintyg eller uppfylla en mottagares krav.",
      intygCta: "Läs mer och välj prov",
      privatTitle: "Övrig privat drogtestning",
      privatText: "För dig som vill ordna drogprov utan en beställning från arbetsgivare eller krav på intyg.",
      privatCta: "Läs mer och välj prov",
      metaTitle: "Drogtestning i Göteborg – salivtest och urinprov | Intygsläkaren",
      metaDescription:
        "Boka privat salivtest eller urinprov för 1 500 kr. Analys i samarbete med Unilabs. Företag: offert.",
    },
    privat: {
      label: "Privat drogtestning",
      title: "Drogprov för ditt eget behov",
      subtitle:
        "Boka salivtest eller urinprov direkt på mottagningen i Göteborg. Varje provpaket kostar 1 500 kr. Analyserna som ingår visas nedan.",
      primaryCta: "Välj provpaket och boka",
      secondaryCta: "Andra tester och prislista",
      howTitle: "Så bokar du ditt drogprov",
      howText:
        "Välj salivtest eller urinprov och boka en tid i vår bokningskalender. Ta med giltig legitimation och följ mottagningens instruktioner inför provtagningen.",
      recipientTitle: "Behöver någon annan ta emot resultatet?",
      recipientText:
        "Kontakta oss före bokning om en arbetsgivare eller intygsmottagare ställer särskilda krav på provet. Då kan andra analyser eller provtagningsrutiner behövas.",
      recipientLink: "Läs om drogtestning för ett intyg",
      moreTitle: "Fler eller andra tester?",
      moreText: "Kontakta oss för prislista om du vill beställa andra analyser eller ett större provpaket.",
      moreCta: "Begär prislista",
      metaTitle: "Privat drogtestning – saliv eller urin | Intygsläkaren",
      metaDescription: "Boka privat salivtest eller urinprov i Göteborg för 1 500 kr per provpaket.",
    },
    forIntyg: {
      label: "För ett intyg",
      title: "Drogtestning som underlag för ett intyg",
      subtitle:
        "När ett läkarintyg kräver drogprov börjar vi med att gå igenom vad mottagaren begär. Provtyp, analyser, eventuell övervakning och tidsplan behöver stämma med kraven.",
      primaryCta: "Välj provpaket och boka",
      secondaryCta: "Hjälp mig välja rätt prov",
      distinguishTitle: "Skilj på ett provsvar och ett läkarintyg",
      distinguishText:
        "Ett laboratorieresultat är inte i sig ett läkarintyg. Om du behöver ett intyg planerar vi även läkarbedömning och det övriga underlag som behövs. Du får besked om vad som ingår och pris innan bokning.",
      transportTitle: "Gäller det Transportstyrelsen?",
      transportText:
        "För alkohol- och drogintyg till Transportstyrelsen finns ett eget upplägg med inskrivning och planerad provtagning. Följ det upplägget om du har ett sådant föreläggande.",
      transportCta: "Alkohol- och drogintyg till Transportstyrelsen",
      tellTitle: "Berätta vad intyget gäller",
      tellText:
        "Ange vilken typ av intyg du behöver och vem som ska ta emot det. Själva föreläggandet, journalhandlingar och medicinska uppgifter lämnas senare genom vårdens kontaktvägar.",
      tellCta: "Skicka en förfrågan",
      metaTitle: "Drogtestning för läkarintyg | Intygsläkaren",
      metaDescription:
        "Salivtest och urinprov när ett läkarintyg kräver drogprov. Kontrollera mottagarens krav före bokning.",
    },
    samples: {
      eyebrow: "Privata provpaket · Boka direkt",
      title: "Salivtest eller urinprov",
      intro: "Välj ditt provpaket och boka en tid på mottagningen i Göteborg. Priset är 1 500 kr per paket.",
      intygNote:
        "Kontrollera att provpaketet motsvarar intygsmottagarens krav. Kontakta oss före bokning om du behöver andra analyser, särskilda provtagningsrutiner eller ett läkarintyg.",
      includesLabel: "I provpaketet ingår:",
      bookCta: "Boka {label}",
      readMore: "Läs om {label}",
      extraTests: "Vill du ha fler eller andra tester? Kontakta oss för prislista.",
      priceListCta: "Begär prislista",
      companyQuote: "Är du företag? Kontakta oss för offert på drogtestning.",
      companyQuoteCta: "Begär företagsoffert",
      purposeTitle: "Rätt prov för rätt ändamål",
      purposeText:
        "Om provet ska användas för ett intyg behöver provpaketet och provtagningen motsvara mottagarens krav. Kontakta oss före bokning om du är osäker. Ett provsvar är inte i sig ett läkarintyg.",
      labText:
        "Vi samarbetar med Unilabs för laboratorieanalysen. Ett negativt svar gäller de beställda analyserna och deras gränsvärden.",
      turnaroundTitle: "Svarstid",
      turnaroundText: "Mottagningen informerar om beräknad svarstid för ditt prov.",
      helpIntyg: "Jag behöver hjälp med prov för ett intyg",
      prepTitle: "Inför provtagningen",
      prepNote: "Ändra inte ordinerade läkemedel på egen hand inför provtagningen.",
    },
    book: {
      label: "Boka provtagning",
      title: "Boka {label}",
      subtitle: "Provtagning på mottagningen i Göteborg.",
      includes: "I provpaketet ingår: {analytes}.",
      calendarEyebrow: "{label} · {price}",
      calendarTitle: "Välj en tid för provtagning",
      calendarText:
        "Boka i vår kalender nedan. Ange att bokningen gäller {label} för {price}. Ta med giltig legitimation.",
      intygNote:
        "Kontrollera att provpaketet motsvarar intygsmottagarens krav. Behöver du ett läkarintyg eller andra analyser hjälper vi dig att planera det separat.",
      readMore: "Läs om {label}",
      iframeTitle: "Boka {label} via HLTHY",
    },
    enquiry: {
      label: "Förfrågan",
      title: "Vi hjälper dig planera drogtestningen",
      subtitle:
        "Berätta vilket ändamål och vilken provtyp du behöver. Vill du ha fler eller andra tester än våra provpaket? Kontakta oss för prislista. Vi hjälper dig också med särskilda krav för ett intyg.",
      companyTitle: "Beställer du för ett företag?",
      companyText:
        "Kontakta oss för offert på företagshälsovård, nyanställning och provtagning vid misstanke.",
      companyCta: "Begär företagsoffert",
      phoneText: "Har du frågor? Ring",
      metaTitle: "Förfrågan om drogtestning | Intygsläkaren",
      metaDescription: "Kontakta Intygsläkaren om privata drogtester, prislista eller särskilda intygskrav.",
    },
  },
  en: {
    navLabel: "Drug testing",
    privatePrefix: "Private",
    hub: {
      label: "Drug testing",
      title: "Drug testing with saliva or urine samples",
      subtitle:
        "Book a private saliva or urine test for 1,500 SEK per package. Samples are analysed in collaboration with Unilabs. Businesses: request a quote.",
      primaryCta: "Choose a package and book",
      priceNote: "Private packages · 1,500 SEK",
      purposeTitle: "What is the drug test for?",
      companyTitle: "Drug testing for occupational health",
      companyText: "Preventive, at hiring and with cause. All drug samples receive MRO review.",
      companyCta: "To occupational health",
      intygTitle: "Drug testing for a certificate",
      intygText: "When sampling is part of a medical certificate or must meet a recipient’s requirements.",
      intygCta: "Read more and choose a test",
      privatTitle: "Other private drug testing",
      privatText: "For anyone arranging a drug test without an employer order or certificate requirement.",
      privatCta: "Read more and choose a test",
      metaTitle: "Drug testing in Gothenburg – saliva and urine | Intygsläkaren",
      metaDescription:
        "Book a private saliva or urine drug test for 1,500 SEK. Laboratory analysis with Unilabs. Businesses: request a quote.",
    },
    privat: {
      label: "Private drug testing",
      title: "Drug testing for your own needs",
      subtitle:
        "Book a saliva or urine test directly at our Gothenburg clinic. Each package costs 1,500 SEK. Included analyses are listed below.",
      primaryCta: "Choose a package and book",
      secondaryCta: "Other tests and price list",
      howTitle: "How to book your drug test",
      howText:
        "Choose saliva or urine and book a time in our calendar. Bring valid ID and follow the clinic’s instructions before sampling.",
      recipientTitle: "Does someone else need the result?",
      recipientText:
        "Contact us before booking if an employer or certificate recipient sets special requirements. Other analyses or collection routines may be needed.",
      recipientLink: "Read about drug testing for a certificate",
      moreTitle: "More or different tests?",
      moreText: "Contact us for a price list if you need other analyses or a larger package.",
      moreCta: "Request a price list",
      metaTitle: "Private drug testing – saliva or urine | Intygsläkaren",
      metaDescription: "Book a private saliva or urine drug test in Gothenburg for 1,500 SEK per package.",
    },
    forIntyg: {
      label: "For a certificate",
      title: "Drug testing as supporting evidence for a certificate",
      subtitle:
        "When a medical certificate requires a drug test, we start by reviewing what the recipient asks for. Sample type, analyses, supervision and timing need to match those requirements.",
      primaryCta: "Choose a package and book",
      secondaryCta: "Help me choose the right test",
      distinguishTitle: "A lab result is not a medical certificate",
      distinguishText:
        "A laboratory result alone is not a medical certificate. If you need a certificate we also plan the medical assessment and other supporting information. You get clarity on what is included and the price before booking.",
      transportTitle: "Is it for the Swedish Transport Agency?",
      transportText:
        "Alcohol and drug certificates for the Swedish Transport Agency follow a separate registration and sampling plan. Use that pathway if you have such a decision.",
      transportCta: "Alcohol and drug certificates for Transportstyrelsen",
      tellTitle: "Tell us what the certificate is for",
      tellText:
        "State the type of certificate and who will receive it. The decision letter, medical records and medical details are submitted later through care channels.",
      tellCta: "Send an enquiry",
      metaTitle: "Drug testing for a medical certificate | Intygsläkaren",
      metaDescription:
        "Saliva and urine testing when a medical certificate requires a drug test. Check the recipient’s requirements before booking.",
    },
    samples: {
      eyebrow: "Private packages · Book directly",
      title: "Saliva test or urine test",
      intro: "Choose your package and book a time at our Gothenburg clinic. The price is 1,500 SEK per package.",
      intygNote:
        "Check that the package matches the certificate recipient’s requirements. Contact us before booking if you need other analyses, special collection routines or a medical certificate.",
      includesLabel: "The package includes:",
      bookCta: "Book {label}",
      readMore: "Read about {label}",
      extraTests: "Need more or different tests? Contact us for a price list.",
      priceListCta: "Request a price list",
      companyQuote: "Ordering for a company? Contact us for a drug-testing quote.",
      companyQuoteCta: "Request a company quote",
      purposeTitle: "The right sample for the right purpose",
      purposeText:
        "If the sample is for a certificate, the package and collection must match the recipient’s requirements. Contact us before booking if you are unsure. A lab result is not itself a medical certificate.",
      labText:
        "We collaborate with Unilabs for laboratory analysis. A negative result applies to the ordered analyses and their cut-off levels.",
      turnaroundTitle: "Turnaround time",
      turnaroundText: "The clinic will tell you the expected turnaround for your sample.",
      helpIntyg: "I need help with a sample for a certificate",
      prepTitle: "Before sampling",
      prepNote: "Do not change prescribed medicines on your own before sampling.",
    },
    book: {
      label: "Book sampling",
      title: "Book {label}",
      subtitle: "Sampling at our Gothenburg clinic.",
      includes: "The package includes: {analytes}.",
      calendarEyebrow: "{label} · {price}",
      calendarTitle: "Choose a sampling time",
      calendarText:
        "Book in the calendar below. Note that the booking is for {label} at {price}. Bring valid ID.",
      intygNote:
        "Check that the package matches the certificate recipient’s requirements. If you need a medical certificate or other analyses, we can plan that separately.",
      readMore: "Read about {label}",
      iframeTitle: "Book {label} via HLTHY",
    },
    enquiry: {
      label: "Enquiry",
      title: "We’ll help you plan the drug testing",
      subtitle:
        "Tell us the purpose and preferred sample type. Need more or different tests than our packages? Ask for a price list. We also help with special certificate requirements.",
      companyTitle: "Ordering for a company?",
      companyText:
        "Contact us for a quote on occupational health, hiring and reasonable-suspicion testing.",
      companyCta: "Request a company quote",
      phoneText: "Questions? Call",
      metaTitle: "Drug testing enquiry | Intygsläkaren",
      metaDescription: "Contact Intygsläkaren about private drug tests, price lists or special certificate requirements.",
    },
  },
} as const;

export type DrugTestingCopy = (typeof drugTestingPages)["sv"];
